module.exports = __webpack_public_path__ + "fonts/iconfont.c5348ed7.ttf";